function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.62 1H6.15A1.55 1.55 0 005 1.55L1.3 5.23a1.34 1.34 0 00-.3.83v18.62a1.34 1.34 0 00.3.83L5 28.8a1.58 1.58 0 001.2.55h14.42a1.58 1.58 0 001.2-.55l3.65-3.29a1.34 1.34 0 00.3-.83V6.06a1.34 1.34 0 00-.3-.83l-3.65-3.68a1.55 1.55 0 00-1.2-.55z",
  fill: "#231f20",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 5.41a2.28 2.28 0 00-.14.8v18.55a2.66 2.66 0 00.18 1h-3.19v-9.58H9.5v9.67H5.9a2.65 2.65 0 00.29-1.06c0-.79.1-16.87 0-18.14A5.12 5.12 0 006 5.64c1.15 0 2.61-.07 3.49-.1v9.58h.75l6.86-.06h.74V5.49L21 5.41m1.85-.78c-1.35 0-5.75.13-5.75.13v9.54l-6.85.06v-9.6S7 4.89 5.3 4.89h-.65c.28 0 .71.73.8 1.87s0 17.05 0 18A2.18 2.18 0 014 26.66l6.3-.06v-9.67h6.8v9.6s3.91-.06 5.44-.06a2.1 2.1 0 01-.93-1.7V6.2a1.7 1.7 0 011.24-1.57zm-18.22.25z",
  fill: "#fff",
  opacity: 0.5
})));

function SvgRatingH(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26.77 30.35"
  }, props), _ref);
}

export default SvgRatingH;